package com.rainbowclubs.rainbow.presentation.admin

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.rainbowclubs.rainbow.data.requests.CreateEventRequest
import com.rainbowclubs.rainbow.domain.use_cases.events.CreateEventUseCase
import kotlinx.coroutines.channels.Channel
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.receiveAsFlow
import kotlinx.coroutines.launch
import rainbowclubs.composeapp.generated.resources.Res
import rainbowclubs.composeapp.generated.resources.event_form_error

class CreateEventViewModel(
    private val clubId: String,
    private val createEventUseCase: CreateEventUseCase,
) : ViewModel() {

    sealed class NavigationEvent {
        object Back : NavigationEvent()
    }

    private val _uiState = MutableStateFlow(EventFormUiState())
    val uiState: StateFlow<EventFormUiState> = _uiState.asStateFlow()

    private val navigationIntentChannel = Channel<NavigationEvent>(Channel.BUFFERED)
    val navigationIntent: Flow<NavigationEvent> = navigationIntentChannel.receiveAsFlow()

    fun onTitleChanged(value: String) {
        _uiState.value = _uiState.value.copy(
            title = value,
            titleError = null,
            validationError = null,
            formError = null,
        )
    }

    fun onDescriptionChanged(value: String) {
        _uiState.value = _uiState.value.copy(
            description = value,
            descriptionError = null,
            validationError = null,
            formError = null,
        )
    }

    fun onLocationChanged(value: String) {
        _uiState.value =
            _uiState.value.copy(location = value, validationError = null, formError = null)
    }

    fun onDateChanged(value: String) {
        _uiState.value = _uiState.value.copy(
            date = value,
            dateError = null,
            validationError = null,
            formError = null,
        )
    }

    fun onEndDateChanged(value: String) {
        _uiState.value = _uiState.value.copy(
            endDate = value,
            endDateError = null,
            validationError = null,
            formError = null,
        )
    }

    fun onStartsAtChanged(value: String) {
        _uiState.value = _uiState.value.copy(
            startsAt = value,
            startsAtError = null,
            validationError = null,
            formError = null,
        )
    }

    fun onEndsAtChanged(value: String) {
        _uiState.value = _uiState.value.copy(
            endsAt = value,
            endsAtError = null,
            validationError = null,
            formError = null,
        )
    }

    fun createEvent() {
        val validation = validateEventForm(_uiState.value)
        val timestamps = validation.timestamps
        if (timestamps == null) {
            _uiState.value = validation.form
            return
        }

        viewModelScope.launch {
            _uiState.value = validation.form.copy(isSubmitting = true)

            createEventUseCase(
                CreateEventRequest(
                    clubId = clubId,
                    startsAt = timestamps.startsAt,
                    endsAt = timestamps.endsAt,
                    description = validation.form.description.trim(),
                    title = validation.form.title.trim(),
                    location = validation.form.location.trim().ifBlank { null },
                )
            ).onSuccess {
                navigationIntentChannel.send(NavigationEvent.Back)
            }.onFailure {
                _uiState.value = validation.form.copy(
                    formError = Res.string.event_form_error,
                    isSubmitting = false,
                )
            }
        }
    }
}
